
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import ConstructionIcon from "@mui/icons-material/Construction";
import WeekendIcon from "@mui/icons-material/Weekend";

import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import BoltIcon from "@mui/icons-material/Bolt";
import BrushIcon from "@mui/icons-material/Brush";
import UpdateIcon from "@mui/icons-material/Update";

import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import ChairIcon from "@mui/icons-material/Chair";
import WbIncandescentIcon from "@mui/icons-material/WbIncandescent";
import PaletteIcon from "@mui/icons-material/Palette";
import SpaIcon from "@mui/icons-material/Spa";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import HandymanIcon from "@mui/icons-material/Handyman";
import OtherHousesIcon from "@mui/icons-material/OtherHouses";

import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import DescriptionIcon from "@mui/icons-material/Description";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

export const ServicesData = [
    {
        id: "planning",
        title: "House Planning and Design",
        path: "/services/planning",
        icon: <DesignServicesIcon />,
        description:
            "Thoughtfully planned and customized house designs that balance aesthetics, functionality, and future needs.",
        details: [
            "Customizable layouts tailored to lifestyle needs",
            "Functional and efficient space planning",
            "Natural light and cross ventilation optimization",
            "Sustainable and energy-efficient design approach",
            "Indoor–outdoor living integration",
            "Personalized interior planning support",
            "Designs adaptable to site conditions",
            "Provision for future expansion",
        ],
    },

    {
        id: "approval",
        title: "Plan Approval",
        path: "/services/approval",
        icon: <AssignmentTurnedInIcon />,
        description:
            "End-to-end plan approval services ensuring smooth compliance with all legal and regulatory requirements.",
        details: [
            "Initial consultation and plan verification",
            "Preparation of architectural and engineering documents",
            "Submission to municipal and local authorities",
            "Coordination during authority plan reviews",
            "Handling corrections and compliance feedback",
            "Obtaining approvals and building permits",
            "Support until construction commencement",
        ],
    },

    {
        id: "construction",
        title: "Construction",
        path: "/services/construction",
        icon: <ConstructionIcon />,
        description:
            "Reliable end-to-end construction services delivering durable, high-quality residential and commercial buildings.",
        details: [
            "Turnkey residential construction",
            "Commercial building projects",
            "Renovation and remodeling works",
            "Quality material sourcing and execution",
            "Strict quality assurance and inspections",
            "On-time project delivery management",
        ],
    },

    {
        id: "interior",
        title: "Interior Design",
        path: "/services/interior",
        icon: <WeekendIcon />,
        description:
            "Customized interior design solutions that combine style, comfort, and functionality for modern living.",
        details: [
            "Personalized interior design concepts",
            "Efficient space planning and layouts",
            "Custom furniture and cabinetry solutions",
            "Lighting design and ambiance planning",
            "Material, color, and finish selection",
            "Eco-friendly and sustainable interiors",
            "3D visualization and virtual walkthroughs",
            "Seamless design-to-execution integration",
            "Turnkey interior design solutions",
        ],
    },
];

export const housePlanningServicesData = [
    {
        icon: <SettingsSuggestIcon fontSize="large" />,
        title: "Customizable Layouts",
        text: "Our layouts cater to individual needs, featuring open-concept spaces, multi-story options, or work-family balance areas, ensuring seamless flow, maximum space utilization, and tailored designs for your ideal home setup.",
        iconColor: "#4285f4",
    },
    {
        icon: <ArchitectureIcon fontSize="large" />,
        title: "Functional And Efficient Design",
        text: "Every plan balances beauty and practicality, optimizing traffic flow, storage, and usability. We prioritize detail to ensure homes meet daily needs while maintaining a comfortable, efficient living environment.",
        iconColor: "#708999ff",
    },
    {
        icon: <WbSunnyIcon fontSize="large" />,
        title: "Natural Light And Ventilation",
        text: "Strategic placement of windows, doors, and open spaces allows natural light and ventilation to enhance interiors, creating bright, airy, energy-efficient homes that feel fresh and inviting year-round.",
        iconColor: "#fdbd00",
    },
    {
        icon: <BoltIcon fontSize="large" />,
        title: "Sustainability And Energy Efficiency",
        text: "We include eco-friendly practices, energy-efficient insulation, and durable materials to reduce environmental impact, offering sustainable homes that provide cost savings and comfort for the long term.",
        iconColor: "#0f9d58",
    },
    {
        icon: <WeekendIcon fontSize="large" />,
        title: "Indoor-Outdoor Living",
        text: "Our plans emphasize seamless indoor-outdoor integration with patios, backyards, or terraces. These designs enhance outdoor enjoyment and bring natural elements closer to your daily living experience.",
        iconColor: "#9e5f11ff",
    },
    {
        icon: <BrushIcon fontSize="large" />,
        title: "Personalized Interior Design",
        text: "From flooring to lighting, our designs complement architecture with cohesive interiors. Custom finishes and thoughtful details create functional, stylish spaces tailored to your preferences.",
        iconColor: "#ea4335",
    },
    {
        icon: <ConstructionIcon fontSize="large" />,
        title: "Adaptable To Site Conditions",
        text: "Our plans suit various terrains and climates, ensuring designs match land characteristics and comply with local rules, whether for urban, suburban, or rural projects.",
        iconColor: "#4285f4",
    },
    {
        icon: <UpdateIcon fontSize="large" />,
        title: "Future Expansion",
        text: "We include provisions for future growth, allowing for additional rooms, floors, or multi-purpose spaces. Plans adapt to your changing lifestyle or family needs effortlessly.",
        iconColor: "#b37a78ff",
    },
];

export const interiorServicesData = [
    {
        icon: <DesignServicesIcon fontSize="large" />,
        title: "Personalized Design Concepts",
        text: "Every project begins with you. We create tailored designs that reflect your vision, style, and needs—whether contemporary, traditional, or eclectic—crafting interiors that are uniquely yours and perfectly suited to your lifestyle.",
        iconColor: "#4285f4",
    },
    {
        icon: <ViewQuiltIcon fontSize="large" />,
        title: "Space Planning & Functionality",
        text: "We design interiors that are both beautiful and functional, optimizing space for your needs. From maximizing small storage to creating open layouts, our designs enhance how you live, work, and relax.",
        iconColor: "#fdbd00",
    },
    {
        icon: <ChairIcon fontSize="large" />,
        title: "Custom Furniture & Fixtures",
        text: "At VR Builders and Promoters, we provide custom furniture solutions, including bespoke cabinetry, built-in shelving, and unique furniture pieces, ensuring your interiors are stylish, functional, and truly one-of-a-kind.",
        iconColor: "#9e5f11ff",
    },
    {
        icon: <WbIncandescentIcon fontSize="large" />,
        title: "Lighting Design",
        text: "Lighting is key to great design. We balance function and aesthetics to illuminate spaces beautifully and enhance ambiance. Using natural light, pendants, or accents, we create a welcoming atmosphere that highlights your interior's charm.",
        iconColor: "#fdbd00",
    },
    {
        icon: <PaletteIcon fontSize="large" />,
        title: "Material & Color Selection",
        text: "We help you choose materials and colors that elevate your space, from durable finishes and flooring to fabrics and paint. Whether sustainable or luxurious, our options ensure style, quality, and easy maintenance within your budget.",
        iconColor: "#ea4335",
    },
    {
        icon: <SpaIcon fontSize="large" />,
        title: "Sustainability & Eco-Friendly",
        text: "We prioritize quality and sustainability by incorporating eco-friendly practices like sustainable materials, energy-efficient lighting, and designs that enhance indoor air quality, creating spaces that are both beautiful and environmentally responsible.",
        iconColor: "#0f9d58",
    },
    {
        icon: <ViewInArIcon fontSize="large" />,
        title: "3D Visualization & Virtual Tours",
        text: "We provide 3D renderings and virtual tours to help you visualize your space before work begins, enabling confident decisions on layout, finishes, and colors, ensuring your vision aligns perfectly with the final design.",
        iconColor: "#4285f4",
    },
    {
        icon: <HandymanIcon fontSize="large" />,
        title: "Seamless Integration",
        text: "Our design team collaborates with construction experts to ensure seamless design-to-build integration. From concept to execution, we manage every detail efficiently, delivering high-quality results that align with your vision.",
        iconColor: "#ea4335",
    },
    {
        icon: <OtherHousesIcon fontSize="large" />,
        title: "Turnkey Interior Design Solutions",
        text: "We provide turnkey interior design services for a hassle-free experience, managing everything from planning to final touches, including furniture, artwork, and deliveries, so you can move in and enjoy your beautifully designed space.",
        iconColor: "#9e5f11ff",
    },
];

export const planApprovalServicesData = [
    {
        icon: <PersonSearchIcon fontSize="large" />,
        title: "Initial Consultation",
        text: "We review and finalize your house plan, ensuring it meets personal preferences and adheres to building codes and zoning laws, making necessary adjustments for a compliant and satisfying design.",
        iconColor: "#fdbd00",
    },
    {
        icon: <DescriptionIcon fontSize="large" />,
        title: "Document Preparation",
        text: "Our team prepares essential documents like architectural drawings, engineering reports, site plans, and energy calculations, ensuring compliance with local authority requirements for seamless submission.",
        iconColor: "#4285f4",
    },
    {
        icon: <DriveFolderUploadIcon fontSize="large" />,
        title: "Submission To Authorities",
        text: "We handle the submission of house plans and related documents to local building authorities, ensuring complete and compliant applications for smooth regulatory approval.",
        iconColor: "#0f9d58",
    },
    {
        icon: <FactCheckIcon fontSize="large" />,
        title: "Plan Review",
        text: "Authorities review your plans for compliance with safety regulations, zoning laws, and environmental considerations. We address feedback to ensure approval.",
        iconColor: "#4285f4",
    },
    {
        icon: <VerifiedUserIcon fontSize="large" />,
        title: "Approval And Permits",
        text: "Once approved, we acquire necessary building permits, inform you about fees, and prepare for construction, ensuring adherence to regulatory requirements.",
        iconColor: "#0f9d58",
    },
    {
        icon: <ConstructionIcon fontSize="large" />,
        title: "Start Construction",
        text: "After approval, construction begins under our expert coordination. We manage inspections to ensure compliance with approved plans and deliver a quality-built home.",
        iconColor: "#fdbd00",
    },
];
